import { SVGProps } from 'react'

export function HeartIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
			<path
				d='M10.9597 2.06665C9.75301 2.06665 8.67301 2.65332 7.99967 3.55332C7.32634 2.65332 6.24634 2.06665 5.03967 2.06665C2.99301 2.06665 1.33301 3.73332 1.33301 5.79332C1.33301 6.58665 1.45967 7.31998 1.67967 7.99998C2.73301 11.3333 5.97967 13.3266 7.58634 13.8733C7.81301 13.9533 8.18634 13.9533 8.41301 13.8733C10.0197 13.3266 13.2663 11.3333 14.3197 7.99998C14.5397 7.31998 14.6663 6.58665 14.6663 5.79332C14.6663 3.73332 13.0063 2.06665 10.9597 2.06665Z'
				fill='currentColor'
			/>
		</svg>
	)
}
